<template>
  <div class="page">404</div>
</template>

<script>
export default {
  name: '',
  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  methods: {}
}
</script>

<style scoped lang="scss">
.page {
}
</style>
